import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';

const WalletWarningModal = ({ open, onClose }) => {
	return <Modal 
                size="tiny"
                open={open} 
                onClose={onClose}>
        <Modal.Header>Wallet</Modal.Header>
        <Modal.Content>Please create a wallet item from the Wallet section.</Modal.Content>
        <Modal.Actions>
            <Button onClick={onClose} primary>Ok</Button>
        </Modal.Actions>
    </Modal>;
};

WalletWarningModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func
};

export default WalletWarningModal;
